<date-picker-range
    [dateRangeObservable]="dateRangeObservable"
    [dateRangeSubject]="dateRangeSubject"
    [report]="true"
></date-picker-range>
